import * as React from "react";
import dayjs from "dayjs";

import { Box, FormControl, FormGroup, FormHelperText, Grid } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";

import CustomInput from "../../../../helper-components/input/CustomInput";
import CustomButton from "../../../../helper-components/input/CustomButton";

import { validateRow } from "../../../../helper-functions/validation/objectValidation";
import { addFormToObj, setInsertObjectState, setValue } from "../../../../helper-functions/shared/miscUtils";
import { IS_PATIENT_VALID, PATIENT_VALIDATION } from "../../../../helper-functions/validation/patientValidation";

import { getLanguage } from "../../../../config/language/language";
import { PATIENT_REQUEST_OBJECT } from "../../../../config/constants/Constants";

/**
 * A form to update a patient.
 */

export default function PatientEditForm(props) {
    const { callback, row: existingRow = {} } = props;

    const object = PATIENT_REQUEST_OBJECT;
    const validation = PATIENT_VALIDATION;
    const isValid = IS_PATIENT_VALID;

    const [row, setRow] = React.useState(addFormToObj(JSON.parse(JSON.stringify(object))));

    React.useEffect(() => {
        const newRow = {
            ...row,
            ...existingRow,

            // Convert to dayjs format if datetime exists.
            birth_date: existingRow.birth_date ? dayjs(existingRow.birth_date) : null,
            created_on: existingRow.created_on ? dayjs(existingRow.created_on) : null,
            updated_on: existingRow.updated_on ? dayjs(existingRow.updated_on) : null,

            form: {
                ...row.form,
                ...existingRow.form,
                saved: false
            }
        };
        setInsertObjectState(setRow, newRow);
    }, []);

    const onChange = (obj, key, value) => {
        const newRow = JSON.parse(JSON.stringify(row));

        // Restore dayjs objects lost during JSON serialization (stringify converts to UTC string)
        if (row.birth_date) newRow.birth_date = row.birth_date;
        if (row.created_on) newRow.created_on = row.created_on;
        if (row.updated_on) newRow.updated_on = row.updated_on;

        setValue(newRow, key, value);
        validateRow(obj, validation, newRow);
        setInsertObjectState(setRow, newRow);
    };

    const handleClick = () => {
        if (!isValid(row)) {
            props.showSnackbar({ message: getLanguage().SNACKBAR_ERROR_FORM_INVALID, color: "error" });
            return;
        }
        const options = { row };
        callback(true, options);
    };

    return (
        <Box className="box">
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <CustomInput name="patient_identifier" row={row} onChange={onChange} label="Patient ID" />
                </Grid>
                <Grid item xs={6}>
                    <CustomInput name="first_name" row={row} onChange={onChange} label="First Name" />
                </Grid>
                <Grid item xs={6}>
                    <CustomInput name="last_name" row={row} onChange={onChange} label="Last Name" />
                </Grid>
                <Grid item xs={12}>
                    <CustomInput name="notes" row={row} onChange={onChange} label="Notes" multiline minRows={2} maxRows={5} />
                </Grid>
                <Grid item xs={12}>
                    <FormControl variant="standard" sx={{ width: "100%" }}>
                        <FormGroup sx={{ alignContent: "center" }}>
                            <DatePicker
                                label="Birth Date"
                                format="MM/DD/YYYY"
                                value={row.birth_date}
                                onChange={(value) => onChange(row, "birth_date", value)}
                                sx={{ width: "100%" }}
                            />
                        </FormGroup>
                        <FormHelperText sx={{ alignSelf: "left", marginLeft: 2 }}>{row?.form?.birth_date?.helperText}</FormHelperText>
                    </FormControl>
                </Grid>
            </Grid>
            <CustomButton {...props} title={"Update patient"} onClick={handleClick} className="button" fullWidth />
        </Box>
    );
}
